export default "__VITE_ASSET__DKZ4fI1l__"